var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHint = function SvgHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.985 5h-1V3h1v2ZM18.016 12v-1h2v1h-2ZM4 11v1.001h2v-1H4ZM6.414 7.122 5 5.708 5.708 5l1.414 1.414-.708.708ZM17.602 7.122l1.414-1.414L18.308 5l-1.414 1.414.708.708Z",
    fill: "#3910ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.984 11c0-2.205 1.795-4 4-4 2.206 0 4 1.795 4 4 0 1.378-.983 2.996-1.985 3.5l.01 2.53c.002.998-.787 1.949-2.016 1.949-1.228 0-1.984-.948-1.984-1.948L10 14.5C9.015 13.978 7.984 12.38 7.984 11ZM13 17.168c-.001.551-.486.83-.984.833-.499.003-1.016-.282-1.016-.833L10.986 15h1.998L13 17.168ZM14.984 11c0-1.654-1.345-3-3-3-1.654 0-3 1.346-3 3 0 .84.35 1.594.907 2.137.092.09.197.162.302.234.162.113.324.225.432.397.031.05.05.13.073.222l.002.01h2.58a.659.659 0 0 1 .067-.246c.105-.167.26-.27.418-.377.101-.068.203-.136.293-.222A2.97 2.97 0 0 0 14.985 11Z",
    fill: "#3910ED"
  })));
};
export default SvgHint;